/**
 * Route for `dynamic-commission-by-order-value-aov`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DynamicCommissionByOrderValueAovPage } from "../features/dynamic-commission-by-order-value-aov/DynamicCommissionByOrderValueAovPage";

export const dynamicCommissionByOrderValueAovRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/dynamic-commission-by-order-value-aov",
	component: DynamicCommissionByOrderValueAovPage,
});

export default dynamicCommissionByOrderValueAovRoute;
